import { Component, Inject } from '@angular/core';
import { TrpcAPIService } from '../trpc-api.service';
import { ActivatedRoute } from '@angular/router';
import { envelopIcon, clipboardIcon } from "@progress/kendo-svg-icons";
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'feedback-form',
  templateUrl: './feedback-form.component.html',
  styles: `
  .screenshot {
    width: 400px;
    height: 400px;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    height: 100%;
  }
  .fbutton {
    width: 100px;
    height: 40px;
  }
  .editor {
    flex-grow: 1;
  }
  `
})
export class FeedbackFormComponent {

  constructor(@Inject('ServerApi') private trpc: TrpcAPIService, private route:ActivatedRoute, private dialogService: DialogService) {
    this.route.params.subscribe(params => {
      this.klantNo = params['klantNo'];
    });

  }

  public icon =  envelopIcon;


  public isOpen = false;
  public klantNo = "ZZ0000";
  public bericht: string = "";


  async onFeedback() {

    // await this.trpc.client.sendEmail.mutate({
    //   bericht: this.bericht,
    //   klantNo: this.klantNo
    // });
    await this.trpc.sendEmail(this.klantNo, this.bericht);
    const dialog: DialogRef = this.dialogService.open({
      title: "Bericht verzonden",
      content: "Bericht verzonden!",
      actions: [{ text: "Close", themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });
    
    this.bericht = "";
    this.isOpen = false;
  }


}
